import { Map, List } from 'immutable';
import _ from 'lodash';

import BaseStore from './BaseStore';
import SeasonFilters from '../records/SeasonFilters';
import { ActionTypes } from '../constants/AppConstants';
import config from '../config';

let seasonFilters = new SeasonFilters();


const getUniqueRoutes = (fares) => {
    return fares.reduce((acc, fare) => {
        const found = acc.find((r) => r.id === fare.route.id);
        return found ? acc : acc.push(fare.route);
    }, new List());
};

const buildRouteFilters = (routes) => {
    return routes.map((route) => new Map({ route, checked: true }));
};


class SeasonFiltersStore extends BaseStore {

    getCurrent () {
        return seasonFilters;
    }

    setCurrent (newSeasonFilters) {
        seasonFilters = newSeasonFilters;
        return this.getCurrent();
    }

    handleSearchStarted ({ search }) {
        const options = _.pick(search.toJS(), 'flexi', 'weekly', 'fourWeekly', 'monthly', 'quarterly', 'sixMonthly', 'annual', 'custom');
        options.firstClass = config.get('brand') !== 'southeastern';
        const newSeasonFilters = new SeasonFilters(options);

        this.setCurrent(newSeasonFilters);
        this.emitChange();
    }

    handlePointSearchFinished ({ seasonTickets }) {
        this.handleSearchFinished(seasonTickets);
    }

    handleFareSearchFinished ({ fares }) {
        this.handleSearchFinished(fares);
    }

    handleSearchFinished (fares) {
        const newRoutes = buildRouteFilters(getUniqueRoutes(fares));
        const newSeasonFilters = seasonFilters.set('routes', newRoutes);
        this.setCurrent(newSeasonFilters);
        this.emitChange();
    }

    handleResultsFilterChange ({ filters }) {
        this.setCurrent(filters);
        this.emitChange();
    }

    getActionHandlers () {
        return {
            [ ActionTypes.SEASON_SEARCH_STARTED ]: this.handleSearchStarted,
            [ ActionTypes.SEASON_SEARCH_FINISHED ]: this.handlePointSearchFinished,
            [ ActionTypes.FARE_ONLY_SEASON_SEARCH_FINISHED ]: this.handleFareSearchFinished,
            [ ActionTypes.SEASON_RESULTS_FILTERS_CHANGE ]: this.handleResultsFilterChange,
        };
    }
}

const storeInstance = new SeasonFiltersStore();

export default storeInstance;
